import { render, staticRenderFns } from "./NauticalCategorySchool.vue?vue&type=template&id=11a294ef&scoped=true"
import script from "./NauticalCategorySchool.vue?vue&type=script&lang=js"
export * from "./NauticalCategorySchool.vue?vue&type=script&lang=js"
import style0 from "./NauticalCategorySchool.vue?vue&type=style&index=0&id=11a294ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a294ef",
  null
  
)

export default component.exports